export const SET_SESSION = 'SET_SESSION';
export const REMOVE_SESSION = 'REMOVE_SESSION';